import { Component } from '@angular/core';

@Component({
  selector: 'app-features-page',
  templateUrl: './features.component.html',
  standalone: false,
  styleUrl: './features.component.scss'
})
export class FeaturesPageComponent {}
